import Navigation from './Navigation'

export default function Header () {
    return (
        <div>
            <div>
                <Navigation />
            </div>
        </div>
    )
}